import { type NotificationsNamespace } from '../en-US/notifications';

export const notifications = {
  update_group_error: 'Se produjo un error al actualizar tus grupos de la comunidad.',
  update_group_success: '¡Tus grupos comunitarios se han actualizado!',
} as const satisfies NotificationsNamespace;
